










import { defineComponent } from '@vue/composition-api';
import { LinkType } from '~/types/components/Link/LinkType';
import Link from '~/components/atoms/Link/Link.vue';

export default defineComponent({
  name: 'LearnMore',
  components: {
    Link,
  },
  props: {
    link: {
      type: String,
      required: true,
    },
    isJustifiedToRight: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return { LinkType };
  },
});
